import { DateTime } from 'luxon';

/** Liste ordonnée des fuseaux IANA proposés (même liste que les paramètres du compte). */
export const TIMEZONE_VALUES = [
  'Etc/GMT+12',
  'Pacific/Pago_Pago',
  'Pacific/Honolulu',
  'America/Anchorage',
  'America/Los_Angeles',
  'America/Denver',
  'America/Chicago',
  'America/New_York',
  'America/Halifax',
  'America/Argentina/Buenos_Aires',
  'America/Noronha',
  'Atlantic/Azores',
  'Europe/London',
  'Europe/Paris',
  'Europe/Athens',
  'Europe/Moscow',
  'Asia/Dubai',
  'Asia/Karachi',
  'Asia/Dhaka',
  'Asia/Bangkok',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Australia/Sydney',
  'Pacific/Noumea',
  'Pacific/Auckland',
  'Pacific/Tongatapu',
  'Pacific/Kiritimati',
] as const;

export const DEFAULT_TIMEZONE = 'Europe/Paris';

/** Offset réel (DST-aware) d'un fuseau à une date donnée, formaté « UTC+2 » / « UTC-3:30 ».
 *  `referenceISODate` : instant/date de référence (UTC ISO ou yyyy-MM-dd) ; à défaut, maintenant. */
export function formatUtcOffset(timezone: string, referenceISODate?: string): string {
  const dt = referenceISODate
    ? DateTime.fromISO(referenceISODate, { zone: timezone })
    : DateTime.now().setZone(timezone);
  const reference = dt.isValid ? dt : DateTime.now().setZone(timezone);
  const offsetMinutes = reference.offset;
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absMinutes = Math.abs(offsetMinutes);
  const hours = Math.floor(absMinutes / 60);
  const minutes = absMinutes % 60;
  const offset =
    minutes === 0 ? `${sign}${hours}` : `${sign}${hours}:${String(minutes).padStart(2, '0')}`;
  return `UTC${offset}`;
}

/** Options du sélecteur avec un offset DST-aware calculé à la date de référence fournie.
 *  Ex. Europe/Paris → « (UTC+2) » en été, « (UTC+1) » en hiver. */
export function getTimezoneOptions(referenceISODate?: string): { value: string; label: string }[] {
  return TIMEZONE_VALUES.map((value) => ({
    value,
    label: `${value} (${formatUtcOffset(value, referenceISODate)})`,
  }));
}
